import { SvgIcon, SvgIconProps } from "@mui/material";

export const H3Icon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M18.95 19.09c-.477 0-.902-.082-1.275-.247a2.176 2.176 0 0 1-.88-.684 1.719 1.719 0 0 1-.328-1.01h1.393c.009.16.06.3.157.422.098.12.228.212.39.278.162.067.344.1.546.1.211 0 .398-.038.56-.112a.917.917 0 0 0 .38-.31.782.782 0 0 0 .137-.457.765.765 0 0 0-.147-.464.94.94 0 0 0-.415-.32 1.616 1.616 0 0 0-.64-.114h-.61v-1.017h.61c.21 0 .394-.036.553-.108a.892.892 0 0 0 .378-.3.78.78 0 0 0 .134-.455.785.785 0 0 0-.445-.725c-.138-.07-.3-.106-.485-.106-.188 0-.36.034-.515.103a.9.9 0 0 0-.374.284.749.749 0 0 0-.15.435h-1.326c.006-.377.114-.71.322-.997.21-.288.49-.513.844-.675a2.846 2.846 0 0 1 1.205-.246c.452 0 .847.082 1.186.246.339.164.602.386.79.665.189.277.283.588.28.933.003.367-.111.672-.341.917-.229.245-.526.401-.892.467v.051c.481.062.848.23 1.1.502.253.27.379.61.376 1.016.003.373-.105.704-.322.994-.216.29-.513.518-.892.684a3.22 3.22 0 0 1-1.304.25Z"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M5 6v12M13 6v12M5 12h8"
      />
    </svg>
  </SvgIcon>
);
